import identityClient from 'clients/identityClient';
import AuthWrapper from 'components/AuthWrapper';
import AuthWrapperFooter from 'components/AuthWrapperFooter';
import HpaStoreContext from 'contexts/HpaStoreContext';
import PropTypes from 'prop-types';
import { useContext, useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import locationShape from 'shapes/locationShape';
import ssoIntegrationOptionsShape from 'shapes/ssoIntegrationOptionsShape';
import {
    error as err,
    setGenericError,
} from '../../../containers/NewRegistrationFlow/PreSignUp';
import errorMessages from '../../../helpers/errorMessages';
import LinkingRegistrationForm from './LinkingRegistrationForm';
import { getCustomBrandingDetail } from '../../../helpers/customBranding';

const LinkingRegistration = ({
    location,
    handleRememberMeChange,
    ssoIntegrationOptions,
    username,
    workflowType,
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(err);
    const context = useContext(HpaStoreContext);
    const locationHook = useLocation();
    const params = locationHook.search;
    const { state } = locationHook || {};
    const history = useHistory();
    const queryString = params ? `${params}` : '';

    const [paramFirstName, setFirstName] = useState('');
    const [paramLastName, setLastName] = useState('');

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const fName = params.get('firstname');
        const lName = params.get('lastname');
        if (fName) {
            setFirstName(fName);
        }
        if (lName) {
            setLastName(lName);
        }
    }, []);

    const customBrandingDisplayName = getCustomBrandingDetail(context, 'displayName');

    const handleLinkingRegistrationwithUsername = async (
        username,
        workflowType,
    ) => {
        try {
            const validationResponse = await identityClient.preRegistrationValidation(
                username,
                queryString,
                workflowType,
            );
            const {
                isProvisioned,
                isConfirmed,
                hStreamId,
                firstName,
                lastName,
                latestPersonId,
                mobileNumberExists,
            } = validationResponse?.data;
            if (isConfirmed && !isProvisioned) {
                history.push({
                    pathname: '/account/matchFound',
                    search: queryString,
                    state: {
                        username,
                        hStreamId,
                        workflowType,
                        isConfirmed: true,
                        isProvisioned: false,
                        firstName: firstName || paramFirstName,
                        lastName: lastName || paramLastName,
                        mobileNumberExists: mobileNumberExists,
                    },
                });
            } else if (isProvisioned) {
                history.push({
                    pathname: '/account/link/claimaccount',
                    search: queryString,
                    state: {
                        username,
                        hStreamId: hStreamId,
                        firstName: firstName || paramFirstName || '',
                        lastName: lastName || paramLastName || '',
                        latestPersonId: latestPersonId,
                        workflowType,
                        isProvisioned: true,
                        isConfirmed: isConfirmed,
                        mobileNumberExists: mobileNumberExists,
                    },
                });
            } else {
                history.push({
                    pathname: '/account/noMatchFound',
                    search: queryString,
                    state: {
                        username,
                        workflowType,
                        firstName: firstName || paramFirstName,
                        lastName: lastName || paramLastName,
                    },
                });
            }
        } catch (e) {
            if (e.status === 409) {
                if (
                    e.response &&
                    e.response.data &&
                    e.response.data.detail ===
                    'Multiple provisioned records or unconfirmed with UserProfiles are available'
                ) {
                    setError((_error) => ({
                        ..._error,
                        errorMessage: errorMessages.multipleProvisioned.message,
                        button: {
                            text: 'Need Help?',
                            link: '/needHelp',
                            id: 'needHelp',
                        },
                    }));
                }
            } else {
                setGenericError(setError);
            }
            setIsLoading(false);
        }
    };

    const onSubmit = async (values) => {
        if (isLoading) return;
        setIsLoading(true);
        handleRememberMeChange(values.remember_me);
        try {
            await handleLinkingRegistrationwithUsername(
                values.username,
                workflowType,
            );
        } catch (error) {
            setGenericError(setError);
        } finally {
            setIsLoading(false);
        }
    };

    const getInitialValues = () => ({
        email: context.username || username || '',
        remember_me: ssoIntegrationOptions.rememberMe.value,
    });

    return (
        <div>
            <AuthWrapper
                footer={<AuthWrapperFooter />}
            >
                <LinkingRegistrationForm
                    initialValues={getInitialValues()}
                    onSubmit={onSubmit}
                    location={location}
                    rememberMeValues={ssoIntegrationOptions.rememberMe}
                    isLoading={isLoading}
                    customBrandingDisplayName={customBrandingDisplayName}
                />
            </AuthWrapper>
        </div>
    );
};

LinkingRegistration.propTypes = {
    location: locationShape.isRequired,
    handleRememberMeChange: PropTypes.func.isRequired,
    ssoIntegrationOptions: ssoIntegrationOptionsShape.isRequired,
    username: PropTypes.string,
    workflowType: PropTypes.string,
};

LinkingRegistration.defaultProps = {
    workflowType: undefined,
};

export default LinkingRegistration;